import type { RouteInfo } from "../lib/types"
import { app } from "../store/app"

export function RouteBadge(props: { route: Pick<RouteInfo, "id" | "shortName" | "color" | "textColor"> }) {
  const bg = () => app.routeColor(props.route.id, props.route.color)
  const fg = () => app.routeTextColor(props.route.id, props.route.textColor)

  return (
    <span
      class="route-badge"
      style={{
        background: `#${bg()}`,
        color: `#${fg()}`,
      }}
    >
      {props.route.shortName || props.route.id}
    </span>
  )
}
